import { LocationType } from '@aviv-search/types';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useSerpTranslation } from '../useI18n';
import { NEWBUILDS_ESTATE_TYPE } from './constants';
import { getTitleData } from './getTitleData';
export { getTitleData } from './getTitleData';
const getLocationTitle = ({ labels, radius }) => {
    if (labels.length > 0) {
        const words = [labels[0]];
        if (radius) {
            words.push(`+${radius}km`);
        }
        return words.join(' ');
    }
    return undefined;
};
const getEstateTypePath = (estateType, appName) => {
    if (appName === 'project_serp') {
        return `header.title.${NEWBUILDS_ESTATE_TYPE.includes(estateType) ? `newbuilds_estate_type.${estateType}` : 'real_estate'}`;
    }
    return `header.title.estate_type.${estateType}`;
};
const getSearchTitle = (searchModel, pageData, t, appName) => {
    if (!searchModel)
        return '';
    const { distributionType, estateType, location } = getTitleData(searchModel, pageData.locations);
    const translatedEstateType = t(getEstateTypePath(estateType, appName));
    const translatedDistributionType = t(`header.title.for_distribution_type.${distributionType}`);
    const locationTitle = getLocationTitle(location) ?? '';
    // handling Commute time special case
    const commuteTimeLocation = searchModel.locations?.find((l) => l.type === LocationType.COMMUTE);
    if (commuteTimeLocation) {
        const translatedCommuteMode = t(`header.title.travel_time.${commuteTimeLocation.mode?.toLowerCase()}`);
        return t('header.title.shell_h1_commute', {
            replace: {
                estate_type: translatedEstateType,
                for_distribution_type: translatedDistributionType,
                location: locationTitle,
                commute_time: commuteTimeLocation.duration,
                commute_mode: translatedCommuteMode,
            },
        });
    }
    const nbLocations = location.labels.length;
    const otherLocations = (nbLocations - 1).toString();
    return t('header.title.shell_h1', {
        replace: {
            estate_type: translatedEstateType,
            for_distribution_type: translatedDistributionType,
            location: locationTitle,
            otherLocations,
        },
        count: nbLocations,
    });
};
export const useSearchTitle = ({ searchModel, pageData, updateTrigger, hubContent, appName, }) => {
    const { t } = useSerpTranslation();
    return useMemo(() => {
        if (hubContent?.title)
            return hubContent?.title;
        if (isEmpty(searchModel) || isEmpty(pageData))
            return '';
        return getSearchTitle(searchModel, pageData, t, appName);
    }, [updateTrigger]);
};
